<template>
  <b-card
    title="Personel Arama"
    class="employee-search-card"
  >
    <b-input-group class="mb-1">
      <b-form-input
        v-model="keyword"
        placeholder="Personel adı veya soyadı ile arayın..."
        @keyup.enter="searchData"
      />
      <b-input-group-append>
        <b-button
          variant="primary"
          :disabled="loading"
          @click="searchData"
        >
          <b-spinner
            v-if="loading"
            small
          />
          <feather-icon
            v-else
            icon="SearchIcon"
          />
          ARA
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <!-- Sonuç yok -->
    <div
      v-if="searched && !loading && dataList.length === 0"
      class="text-center text-muted py-2"
    >
      <feather-icon
        icon="UserXIcon"
        size="32"
      />
      <div class="mt-1">
        Aramanızla eşleşen personel bulunamadı.
      </div>
    </div>

    <!-- Sonuç listesi (scrollable) + detay -->
    <b-row v-else-if="dataList.length > 0">
      <!-- Liste (yalnız birden fazla sonuçta) -->
      <b-col
        v-if="dataList.length > 1"
        cols="12"
        md="5"
        class="mb-1 mb-md-0"
      >
        <div class="employee-results">
          <b-list-group flush>
            <b-list-group-item
              v-for="item in dataList"
              :key="item.id"
              button
              :active="selected && selected.id === item.id"
              class="d-flex align-items-center"
              @click="selectItem(item)"
            >
              <b-avatar
                v-if="item.image"
                :src="imageFolder + item.image"
                size="40"
                class="mr-1"
              />
              <b-avatar
                v-else
                :text="initials(item)"
                size="40"
                class="mr-1"
              />
              <div>
                <div class="font-weight-bold">
                  {{ item.name }} {{ item.surname }}
                </div>
                <div class="font-small-3 text-warning">
                  {{ item.title }}
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>

      <!-- Detay -->
      <b-col
        cols="12"
        :md="dataList.length > 1 ? 7 : 12"
      >
        <div
          v-if="selected"
          class="text-center mb-1"
        >
          <b-avatar
            v-if="selected.image"
            :src="imageFolder + selected.image"
            size="110"
          />
          <b-avatar
            v-else
            :text="initials(selected)"
            size="110"
          />
        </div>
        <b-table-simple
          v-if="selected"
          small
          bordered
        >
          <b-tbody>
            <b-tr>
              <b-th width="140">
                Adı Soyadı
              </b-th>
              <b-td>
                {{ selected.name }} {{ selected.surname }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th width="140">
                Görevi
              </b-th>
              <b-td>
                {{ selected.title }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th width="140">
                İşe Başlama
              </b-th>
              <b-td>
                {{ selected.sdate ? moment(selected.sdate).format('LL') : '-' }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th width="140">
                E-Posta
              </b-th>
              <b-td>
                {{ selected.email_address ? selected.email_address : '-' }}
              </b-td>
            </b-tr>
            <b-tr v-if="selected.phone || !selected.internal">
              <b-th width="140">
                İş Telefonu
              </b-th>
              <b-td>
                {{ selected.phone ? selected.phone : '-' }}
              </b-td>
            </b-tr>
            <b-tr v-if="selected.internal">
              <b-th width="140">
                Dahili No
              </b-th>
              <b-td>
                {{ selected.internal ? selected.internal : '-' }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th width="140">
                Departman
              </b-th>
              <b-td>
                {{ selected.department ? selected.department : '-' }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th width="140">
                Lokasyon
              </b-th>
              <b-td>
                {{ selected.location ? selected.location : '-' }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <div
          v-if="selected && selected.resume"
          class="mt-1"
          v-html="selected.resume"
        />
      </b-col>
    </b-row>

    <!-- Başlangıç durumu -->
    <div
      v-else
      class="text-center text-muted py-2"
    >
      <feather-icon
        icon="UsersIcon"
        size="32"
      />
      <div class="mt-1">
        Personel aramak için yukarıdan arama yapın.
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
  BSpinner,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BTableSimple,
  BTbody,
  BTr,
  BTh,
  BTd,
} from 'bootstrap-vue'

export default {
  name: 'EmployeeSearch',
  components: {
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BSpinner,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {
      keyword: '',
      loading: false,
      searched: false,
      selected: null,
      imageFolder: `${this.$store.state.app.baseURL}/media/hr/employees/`,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['employees/getEmployees']
    },
  },
  methods: {
    initials(item) {
      const n = item.name ? item.name[0] : ''
      const s = item.surname ? item.surname[0] : ''
      return (n + s).toUpperCase()
    },
    selectItem(item) {
      this.selected = item
    },
    searchData() {
      if (!this.keyword || this.keyword.trim().length === 0) {
        return
      }
      this.loading = true
      this.selected = null
      this.$store.dispatch('employees/search', this.keyword.trim())
        .then(list => {
          this.searched = true
          if (list.length > 0) {
            const [first] = list
            this.selected = first
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.employee-results {
  max-height: 360px;
  overflow-y: auto;
}
</style>
